import React from 'react'
import PropTypes from 'prop-types'

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isClosing: false,
      isVisible: false
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show) {
      if (this.props.show) {
        // Сначала показываем контейнер, затем запускаем анимацию появления
        this.setState({ isVisible: true }, () => {
          // Небольшая задержка для начала анимации
          setTimeout(() => {
            this.setState({ isClosing: false })
          }, 10)
        })
      } else {
        // Запускаем анимацию закрытия
        this.setState({ isClosing: true })
      }
    }
  }

  handleClose = () => {
    this.setState({ isClosing: true }, () => {
      // После завершения анимации скрываем блок
      setTimeout(() => {
        this.setState({ isVisible: false })
        this.props.close()
      }, 300)
    })
  }

  handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      this.handleClose()
    }
  }

  render() {
    const { prices, show } = this.props
    const { isClosing, isVisible } = this.state

    // Если блок не виден и не показывается, не рендерим ничего
    if (!isVisible && !show) return null

    return (
      <div 
        className={`fixed inset-0 z-[70] transition-all duration-300 ${
          isVisible && !isClosing 
            ? 'bg-black/30 backdrop-blur-sm' 
            : 'bg-transparent'
        }`}
        onClick={this.handleBackdropClick}
      >
        <div className='fixed bottom-0 left-0 w-full'>
          <div className='container px-0'>
            <div className='w-full flex justify-center items-end'>
              <div 
                className={`bg-white rounded-tl-[25px] rounded-tr-[25px] min-h-[315px] px-[15px] pt-[19px] flex-none w-full relative transition-transform duration-300 ease-out ${
                  isVisible && !isClosing 
                    ? 'translate-y-0' 
                    : 'translate-y-full'
                }`}
              >
                <div className='text-black text-[18px] font-semibold'>Условия доставки</div>
                <div className='text-[#00000099] text-[12px] font-normal'>Цена зависит от суммы вашего заказа</div>
                {prices.map((elm, k) => (
                  <div key={k} className='mt-[15px]'>
                    <div className='flex items-center mb-[3px] text-black text-[18px] font-semibold'>
                      <div 
                        style={{ backgroundColor: elm.color }} 
                        className='w-[14px] h-[14px] rounded-full me-[6px]'
                      />
                      <div>{elm.title}</div>
                    </div>
                    <div className='flex items-center justify-between gap-[6px] text-[#00000099] text-[12px] font-normal'>
                      <div>{elm.sum}</div>
                      <div className='flex-1 border-dashed border-b-[#0000001A] border-t-[1px]' />
                      <div>{elm.price}</div>
                    </div>
                  </div>
                ))}
                <button
                  className="mt-[15px] text-[14px] font-inter w-full h-10 rounded-full mb-2 bg-[#5A91FF] text-white disabled:bg-[#5A91FF] disabled:text-[#FFFFFF80] active:scale-[0.98] transition-transform duration-200"
                  onClick={this.handleClose}
                >
                  Продолжить
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Main.propTypes = {
  prices: PropTypes.array,
  show: PropTypes.bool,
  close: PropTypes.func
}

export default Main